import React from "react";
import OntologyForm from "../../components/forms/ontologyForm/CompleteForm";

export const AddOntology = () => {
  return (
    <React.Fragment>
      <OntologyForm />
    </React.Fragment>
  );
};